<template>
	<div class="hierarchy-item tw-flex" :class="{ 'has-error': assignation.hasError }">
		<div class="tw-w-1/5 tw-p-6 job-name-wrapper tw-flex tw-justify-center tw-items-center">
			<p class="tw-m-0 uppercase job-name tw-text-center"> {{ assignation.job }} </p>
		</div>
		<div class="tw-w-4/5 tw-p-6 tw-flex tw-flex-col tw-justify-center">
			<div  class="tw-flex tw-flex-wrap">
				<job-hierarchy-box
					class="tw-mr-4 tw-mb-4"
					v-for="(jobPosition, index) of assignation.jobPositions"
					:assignation-has-error="assignation.hasError"
					:key="index"
					:job-position="jobPosition"
					:selected-job-position='selectedJobPosition'
					:selected="selectedJobPosition.id === jobPosition.id"
					:assignation-id="assignation.id"
					:selectable="level > selectedLevel"
					:clickable="level !== 0 && !selectedJobPositionExists"
					@click="$emit('selectedJobPosition', {jobPosition, level})"
				/>
			</div>
			<div v-if="assignation.hasError" class="error-message tw-px-8 tw-py-2 tw-mt-4">
				<p class="tw-m-0">Solo se debe tener un puesto en este nivel, Editar la descripción del puesto</p>
			</div>
		</div>
	</div>
</template>

<script>
import JobHierarchyBox from '@/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-box';
import { isEmpty, isNil } from 'ramda';

export default {
	name: 'job-hierarchy-level',
	components: { JobHierarchyBox },
	props: ['assignation', 'selectedJobPosition', 'selectedLevel', 'level'],
	computed: {
		selectedJobPositionExists() {
			return !isEmpty(this.selectedJobPosition) && !isNil(this.selectedJobPosition);
		},
	},
};
</script>

<style lang="scss" scoped>
.hierarchy-item {
	border-bottom: 1px dashed #969696;
	min-height: 150px;
	&.has-error {
		.job-name {
			color: var(--app-color-error);
		}
	}

	.job-name-wrapper {
		border-right: 1px solid var(--app-color-primary);
	}
	.job-name {
		color: var(--app-color-primary);
		font-weight: bold;
	}
	.error-message {
		border: 1px solid var(--app-color-error);
		border-radius: 20px;
		color: var(--app-color-error);
		width: 300px;
		background-color: #ffebea;
		p {
			font-size: 12px;
			line-height: 12px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-level.vue